import React from 'react';


const filterOptions = {
  perf24h: [
    { label: 'Toutes', value: '' },
    { label: '> 5%', value: 'gt5' },
    { label: '> 10%', value: 'gt10' },
    { label: '< 0%', value: 'lt0' },
  ],
  momentum: [
    { label: 'Toutes', value: '' },
    { label: 'Forte', value: 'high' },
    { label: 'Faible', value: 'low' },
  ],
  volatility: [
    { label: 'Toutes', value: '' },
    { label: 'Haute', value: 'high' },
    { label: 'Basse', value: 'low' },
  ],
  sector: [
    { label: 'Tous', value: '' },
    { label: 'Layer 1', value: 'layer1' },
    { label: 'DeFi', value: 'defi' },
    { label: 'NFT', value: 'nft' },
    { label: 'Meme', value: 'meme' },
    { label: 'CEX', value: 'cex' },
    { label: 'DEX', value: 'dex' },
  ],
};

const ScannerFilters = ({ filters, setFilters }) => {
  const handleChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  return (
    <div className="scanner-filters">
      <div className="scanner-filter-field">
        <label htmlFor="scanner-filter-perf24h">Performance 24h</label>
        <select id="scanner-filter-perf24h" name="perf24h" value={filters.perf24h || ''} onChange={handleChange}>
          {filterOptions.perf24h.map(opt => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
      </div>
      <div className="scanner-filter-field">
        <label htmlFor="scanner-filter-momentum">Momentum</label>
        <select id="scanner-filter-momentum" name="momentum" value={filters.momentum || ''} onChange={handleChange}>
          {filterOptions.momentum.map(opt => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
      </div>
      <div className="scanner-filter-field">
        <label htmlFor="scanner-filter-volatility">Volatilité</label>
        <select id="scanner-filter-volatility" name="volatility" value={filters.volatility || ''} onChange={handleChange}>
          {filterOptions.volatility.map(opt => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
      </div>
      <div className="scanner-filter-field">
        <label htmlFor="scanner-filter-sector">Secteur</label>
        <select id="scanner-filter-sector" name="sector" value={filters.sector || ''} onChange={handleChange}>
          {filterOptions.sector.map(opt => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default ScannerFilters;
